import { isNull, notDefined } from "@utils/var.check.ts";

export default {
  SELECTOR: ".sls-label",
  retrieveDataFromElement(element) {
    if (notDefined(element) || isNull(element)) {
      return {};
    }
    return {
      kind: element.getAttribute("data-kind"),
      textLabelKey: element.getAttribute("data-text-label-key"),
      classes: element.getAttribute("class"),
    };
  },
};
